import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { SessionQueryProvider } from './session-query.js';
import { RouterProvider } from 'react-router-dom';
import 'antd/dist/reset.css';
import './styles.css';
import { router } from './router.js';
import { AuthProvider } from './auth.js';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} button={{ autoInsertSpace: false }} theme={{ token: { colorPrimary: '#176B67', borderRadius: 8, fontSize: 14 } }}>
      <AuthProvider><SessionQueryProvider><RouterProvider router={router} /></SessionQueryProvider></AuthProvider>
    </ConfigProvider>
  </React.StrictMode>
);
